<template>
  <div
    v-if="showImages && itemImage"
    class="menu-item-image"
    :class="{ unavailable: unavailable }"
    :style="{ 'background-image': isBackground ? `url(${itemImage})` : 'none' }"
  >
    <img v-if="!isBackground && itemImage" v-image-fall-back="itemImgFallback" :src="itemImage" alt="Item image" />
    <img v-if="unavailable" src="@/assets/images/unavailable.png" alt="Item image" class="unavailable-image" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export const fallBackImg =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAQAAACSR7JhAAAASElEQVR42u3OMQEAAAgDINc/9Czh4QEJSDsPRUtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS+vYApullbbA6ZA8AAAAAElFTkSuQmCC";

export const grayFallbackImg =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAIAAAC3LO29AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0lpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUY1RDM2MDg3MkU5MTFFQkFDNDREN0Q2MTg2MkEyQTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUY1RDM2MDc3MkU5MTFFQkFDNDREN0Q2MTg2MkEyQTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjAwODJjZTQxLWQ4ODYtZDU0MS1iMTI5LTk0YWQ4NWRiY2YxYiIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjAwODJjZTQxLWQ4ODYtZDU0MS1iMTI5LTk0YWQ4NWRiY2YxYiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Psps2awAAABhSURBVHja7M8BAQAABAMw9K/2TnqwNVgnqdOmrjM0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NPw4XAEGAL1iAv1Ebo/jAAAAAElFTkSuQmCC";

export default {
  name: "MenuItemImage",
  props: {
    images: Array,
    isBackground: Boolean,
    fullResOnly: Boolean,
    unavailable: Boolean
  },
  data() {
    return {
      itemImgFallback: grayFallbackImg
    };
  },
  computed: {
    ...mapGetters({
      showImages: "venueSettings/showMenuItemsImages"
    }),
    itemImage() {
      return this.images && this.images.length && (this.fullResOnly ? this.images[0].imageFullRes : this.images[0].image);
    }
  }
};
</script>

<style scoped lang="scss">
@include menu-wide {
  .menu-item-image {
    border-radius: 5px;
    flex-basis: 150px;
    min-width: 104px;
    height: 104px;
    img {
      height: 100%;
    }
  }
}

.menu-item-image {
  flex-basis: 75px;
  min-width: 75px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  display: flex;

  &.unavailable {
    opacity: 0.5;
  }

  img {
    max-width: 100%;
  }

  .unavailable-image {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    color: #fff;
    filter: brightness(0) invert(1);
    transform: scale(0.7);
  }
}
</style>
